import styled from '@emotion/styled'
import { Container, Grid } from '@mui/material'
import { breakpoints as bp } from 'shared/style/constants'
import { getPxAsRem } from 'shared/utils'

const breakpoints = {
    mobile: `${bp.sm}px`,
    tablet: `${bp.md}px`,
}

export const AdditionalButtonsContainer = styled.div`
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    max-width: ${getPxAsRem(550)};
    @media (min-width: ${breakpoints.mobile}) and (max-width: ${breakpoints.tablet}) {
        flex-direction: column;
        align-items: stretch;
        max-width: 100%;
    }
`

// styled components for profile + preferences pages with the toggle to edit forms

export const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const EditButtonContainer = styled(Grid)`
    display: flex;
    gap: ${getPxAsRem(8)};

    .MuiCircularProgress-root {
        color: ${({ theme }) => theme.palette.greyscale.white};
    }
`

export const StyledContainer = styled(Container)`
    padding-top: ${getPxAsRem(36)};
    padding-bottom: ${getPxAsRem(36)};
`

export const StyledForm = styled.form`
    margin-top: ${getPxAsRem(16)};
`

export const SubtitleContainer = styled(Grid)`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
